/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-26, 10:33:12
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 10:36:25
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import {
  FILL_FAQ_LIST,
} from './mutation-types';

export default {
  [FILL_FAQ_LIST](state, payload) {
    const _state = state;
    _state.faqList = payload.faqList;
  },
};




// WEBPACK FOOTER //
// ./src/store/modules/Help/mutations.js